<template lang="html">
    <div v-html="text" class="wysiwyg" :class="{'margin-top': spacing_top, 'margin-bottom': spacing_bottom}"></div>
</template>

<script>
  export default {
    name: 'SectionRichText',
    props: {
      text: {
        type: [Boolean, String],
        default: false
      },
      spacing_top: {
        type: [Boolean],
        default: false
      },
      spacing_bottom: {
        type: [Boolean],
        default: false
      }
    }
  }
</script>

<style lang="scss">
    .wysiwyg {
        em {
            font-family: 'HeyAugust';
        }
    }

    .margin-top {
        margin-top: 2em;
    }

    .margin-bottom {
        margin-bottom: 2em;
    }



</style>
